import { Profile, Job, Quote, Message, Notification, Review } from '../types';

export const INITIAL_PROFILES: Profile[] = [
  // Platform Administrator (Root Auth UID)
  {
    id: 'e0e0ec57-cd3a-4f70-b980-c6b5f1ee7cd2',
    role: 'admin',
    fullName: 'Engr. Taiwo Sowore',
    email: 'admin@jobmatch.ng',
    phone: '+234 801 000 9999',
    avatarUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&auto=format&fit=crop&q=80',
    state: 'Lagos',
    lga: 'Ikeja',
    cityArea: 'Ikeja',
    address: 'JobMatch NG HQ, Victoria Island, Lagos',
    bio: 'Platform Quality Assurance & Operations Administrator',
    createdAt: '2023-01-01T00:00:00Z'
  }
];

export const INITIAL_JOBS: Job[] = [];

export const INITIAL_QUOTES: Quote[] = [];

export const INITIAL_MESSAGES: Message[] = [];

export const INITIAL_NOTIFICATIONS: Notification[] = [];

export const INITIAL_REVIEWS: Review[] = [];

